module.exports = __webpack_public_path__ + "img/NancyGriffing.bf6993ab.jpg";